import { API_ENDPOINT } from 'src/config/env.config';
import { BaseAPIResponse } from 'types';
import { baseApi } from './axios';

const baseUrl = API_ENDPOINT;

export const checkResumeContent = async (resumeUrl: string, userId: string): Promise<BaseAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/check-resume`, {
		resumeUrl,
		userId,
	});
	return response.data;
};
